import "./SelectedPackageDetailCard.css";
import { useContext, useState } from "react";
import PropTypes from 'prop-types';

import whatsapp from "../../assets/whatsapp.svg";
import facebook from "../../assets/facebook.svg";
import messenger from "../../assets/messenger.svg";
import twitter from "../../assets/twitter.svg";
import snapchat from "../../assets/snapchat.svg";
import instagram from "../../assets/instagram.svg";

import SelectedPackageBanner from "../SelectedPackageBanner/SelectedPackageBanner";
import { Button } from "../Buttons/Button/Button";

import { REQUEST_BALANCE_HOME } from "../../constants/callTrackingConstants";
import AppContext from "../../AppContext";

const SelectedPackageDetailCard = ({
  product,
  selectedProduct,
  setIsVisiblePopUpDetails,
  setSelectedProduct,
}) => {
  const {
    doCallTracking,
    setErrorProduct,
    errorProduct,
    setErrorName,
    number,
    setErrorNumber,
  } = useContext(AppContext);

  const [packages] = useState({
    1: {
      cardClass: "recharge__card",
      slectedClass: "",
      prefix: "VTAE",
      title: "",
    },
    2: {
      cardClass: "telcel__network__card",
      slectedClass: "",
      prefix: "INT",
      title: "",
    },
    3: {
      cardClass: "recharge__card",
      slectedClass: "",
      prefix: "ILIM",
      title: "",
    },
    4: {
      cardClass: "unlimited__card",
      slectedClass: "unlimited__card__selected",
      prefix: "SL",
      title: "Sin Límite",
    },
    6: {
      cardClass: "entertainment__card",
      slectedClass: "",
      prefix: "RE",
      title: "",
    },
  });

  const {
    category: { categoryId },

    amount,
    pkgInternetMb,
    pkgValidity,
    pkgFb,
    pkgFbMsn,
    pkgTwitter,
    pkgSnapchat,
    pkgInstagram,
    pkgWhatsapp,
    productId,
    pkgType,
  } = product;

  const handleViewDetails = () => {
    setIsVisiblePopUpDetails(true);
    doCallTracking(
      REQUEST_BALANCE_HOME.CLIC_VER_DETALLES.elementName,
      `${REQUEST_BALANCE_HOME.CLIC_VER_DETALLES.elementLocation}${pkgType}`,
      number
    );
  };

  return (
    <div
      className="container__selected__package__detail__card"
      onClick={() => {
        if (errorProduct) {
          setErrorProduct(null);
          setErrorName(null);
          setErrorNumber(null);
        }
        if (selectedProduct?.productId !== productId) {
          setSelectedProduct(product);
          doCallTracking(
            `${REQUEST_BALANCE_HOME.CLIC_PRODUCTO.elementName}${pkgType}`,
            REQUEST_BALANCE_HOME.CLIC_PRODUCTO.elementLocation,
            number
          );
        }
      }}
    >
      <div
        className={`selected__package__card ${
          packages[categoryId] ? packages[categoryId].cardClass : ""
        }
        ${
          selectedProduct?.productId === productId && packages[categoryId]
            ? packages[categoryId].slectedClass
            : ""
        }`}
      >
        <div className="selected__package__info">
          <SelectedPackageBanner product={product} />
          <p className="selected__package__title">{`${
            packages[categoryId] ? packages[categoryId].title : ""
          } ${amount}`}</p>{" "}
          <p className="selected__package__amount">{`$${amount}`}</p>
        </div>

        <div className={`selected__package__benefits`}>
          <p className="selected__package__vigency">
            {pkgInternetMb && `${pkgInternetMb} - `}
            {`Vigencia ${pkgValidity}`}
          </p>
          <div className="container__benefits__icons">
            {pkgWhatsapp && (
              <img src={whatsapp} alt="whatsapp-icon" width="16px" />
            )}
            {pkgFb && <img src={facebook} alt="facebook-icon" />}
            {pkgFbMsn && <img src={messenger} alt="messenger-icon" />}
            {pkgTwitter && <img src={twitter} alt="twitter-icon" />}
            {pkgSnapchat && <img src={snapchat} alt="snapchat-icon" />}
            {pkgInstagram && <img src={instagram} alt="instagram-icon" />}
          </div>
        </div>

        {selectedProduct?.productId === productId && (
          <div className="container__details__section">
            <Button
              btnText="Ver detalles"
              btnStyles="view__details__text"
              handleOnClick={handleViewDetails}
            />

            <span className="indicator__circle" />
          </div>
        )}
      </div>
    </div>
  );
};

SelectedPackageDetailCard.propTypes = {
  product: PropTypes.object,
  selectedProduct: PropTypes.object,
  setIsVisiblePopUpDetails: PropTypes.func,
  setSelectedProduct: PropTypes.func,
};

export default SelectedPackageDetailCard;
